import styled from 'styled-components';

export const FooterWrap = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  & > .menu_footer {
    width: 100%;
    margin-bottom: 30px;
    @media screen and (orientation: portrait) {
      margin-bottom: 0;
    }
  }

  & > p {
    color: rgba(0, 0, 0, 0.50);
    font-size: 12px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.84px;
    text-transform: uppercase;
    display: flex;
    column-gap: 30px;
    @media screen and (orientation: portrait) {
      font-size: 11px;
      column-gap: 10px;
    }

    & > span {
      color: #000;
      font-size: 12px;
      font-weight: 400;
      line-height: 22px;
      letter-spacing: 0.84px;
      text-transform: uppercase;
      cursor: pointer;
    }

    & > a {
      color: #000;
      font-weight: 400;
      line-height: 22px;
      letter-spacing: 0.84px;
      text-transform: uppercase;
      text-decoration: none;
    }
  }

  & > svg {
    cursor: pointer;
  }
`;
